/* eslint-disable jsx-a11y/anchor-is-valid */
import { useContext } from 'react'
import { FC } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../../../../app/modules/auth'
import { currnetCompanyName } from '../../../../app/modules/auth/core/_requests'
import { ProfileContext } from '../../../layout/MasterLayout'

const HeaderUserMenu: FC = () => {
  const profilecontext: any = useContext(ProfileContext)
  const { currentUser, logout } = useAuth()
  const prefixCompany = currnetCompanyName(currentUser?.company)
  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            <img alt={currentUser?.first_name} src={profilecontext?.state?.profilepic.pic} />
          </div>

          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5'>
              {profilecontext?.state?.profilepic.first_name}{' '}
              {profilecontext?.state?.profilepic.last_name}
            </div>
            <a href='#' className='fw-bold text-muted text-hover-primary fs-7'>
              {currentUser?.email}
            </a>
          </div>
        </div>
      </div>
      <div className='separator my-2'></div>
      <div className='menu-item px-5'>
        <Link to={`/${prefixCompany}/time_employee/`} className='menu-link px-5'>
          My Timesheet
        </Link>
      </div>
      <div className='menu-item px-5'>
        <Link to={`/${prefixCompany}/profile/`} className='menu-link px-5'>
          My Profile
        </Link>
      </div>
      <div className='separator my-2'></div>
      <div className='menu-item px-5 my-1'>
        <Link to={`/${prefixCompany}/account/settings`} className='menu-link px-5'>
          Account Settings
        </Link>
      </div>
      <div className='menu-item px-5'>
        <a onClick={logout} className='menu-link px-5'>
          Sign Out
        </a>
      </div>
    </div>
  )
}

export { HeaderUserMenu }
